import { Expose } from "class-transformer";

export class CreateWarehouseDto {
  @Expose()
  name: string;

  @Expose()
  isOpen: boolean;

  @Expose()
  responsableId: string;
}
